import { EntityRepository } from "~/utils";
import { ActionSlotDef } from "./ActionSlot";

export const actionSlotRepository = new EntityRepository<ActionSlotDef>({
  entities: [],
});
